import logo from './logo.svg';
import './App.css';
import MCCBSelector from './MCCBSelector';

function App() {
  return (
    <div className="App">
      <MCCBSelector />
    </div>
  );
}

export default App;
